export const CourseCategoryList = [
  { value: 'Primary Certification',label: 'Primary Certification'},
  { value: 'Continuing Education',label: 'Continuing Education'},
  { value: 'Advanced Specialization' ,label: 'Advanced Specialization'},
]
